var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusRounded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus-circle",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3931",
    "data-name": "Tracciato 3931",
    d: "M12.938,7.875a.562.562,0,0,1,.563.563v4.5a.562.562,0,0,1-.562.563h-4.5a.563.563,0,0,1,0-1.125h3.938V8.438A.562.562,0,0,1,12.938,7.875Z",
    transform: "translate(-3.938 -3.938)",
    fill: "#f0f7fd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3932",
    "data-name": "Tracciato 3932",
    d: "M16.875,17.438a.562.562,0,0,1,.563-.562h4.5a.563.563,0,0,1,0,1.125H18v3.938a.563.563,0,0,1-1.125,0Z",
    transform: "translate(-8.438 -8.438)",
    fill: "#f0f7fd",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3933",
    "data-name": "Tracciato 3933",
    d: "M9,16.875A7.875,7.875,0,1,0,1.125,9,7.875,7.875,0,0,0,9,16.875ZM9,18A9,9,0,1,0,0,9,9,9,0,0,0,9,18Z",
    fill: "#f0f7fd",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusRounded);
export default __webpack_public_path__ + "static/media/PlusRounded.c4a0c6357085992f127f6136b555bec1.svg";
export { ForwardRef as ReactComponent };